import Vue from "vue";
import i18n from "@/plugins/i18n/translations";

Vue.use({
	install(Vue) {
		Vue.prototype.$ActionType = {
			Step: 1,
			Concluded: 2,
			Canceled: 3,
			Integration: 4,
			Returned: 5
		};

		Vue.prototype.$tipoScore = {
			Range: 1,
			List: 2,
			Percetage: 3,
			Image: 4
		};

		Vue.prototype.$permissions = {
			Edit: false,
			Read: false
		};

		Vue.prototype.$tipoCampo = {
			Mandatory: i18n.t("commons.fieldTypeEnum.mandatory"),
			Edition: i18n.t("commons.fieldTypeEnum.edition"),
			ReadOnly: i18n.t("commons.fieldTypeEnum.readOnly"),
			NotIncluded: i18n.t("commons.fieldTypeEnum.notIncluded")
		};

		Vue.prototype.$RequirementStatus = {
			Pending: 1,
			InProgress: 2,
			Done: 3,
			Accepted: 4,
			Rejected: 5,
			Expired: 6,
			InReevaluation: 7,
			PartialAnswer: 8
		};

		Vue.prototype.$ValidityType = {
			Period: 1,
			Date: 2
		};

		Vue.prototype.$IndeterminateValidityEndValue = {
			Date: "31/12/9999"
		};

		Vue.prototype.$ResponseType = {
			FreeText: 1,
			MultipleSelection: 2,
			UniqueSelection: 3,
			Dropdown: 4,
			Concatenation: 5,
			StandardList: 6,
			Email: 7,
			Monetary: 8
		};

		Vue.prototype.$FormType = {
			FillerForm: 1,
			ValidationForm: 2
		};

		Vue.prototype.$SAPIntegration = {
			DISABLED: 0,
			BASIC_AUTH: 1,
			OAUTH2: 2
		};

		Vue.prototype.$SAPIntegration = {
			DISABLED: 0,
			BASIC_AUTH: 1,
			OAUTH2: 2
		};

		Vue.prototype.$StandardListType = {
			Country: 1,
			State: 2,
			City: 3,
			Bank: 4,
			Agency: 5,
			Supplier: 6,
			Answer: 7
		};

		Vue.prototype.$RequirementPersonType = {
			PF: 1,
			PJ: 2,
			NIF: 3
		};

		Vue.prototype.$swalTypes = {
			Success: "success",
			Question: "question",
			Error: "error",
			Info: "info"
		};

		Vue.prototype.$offerStatus = {
			WAITING: 1,
			CANCELED: 2,
			INVITED: 3
		};

		Vue.prototype.$permissions = {
			create: i18n.t("commons.permissionTypeEnum.create"),
			read: i18n.t("commons.permissionTypeEnum.read"),
			update: i18n.t("commons.permissionTypeEnum.update"),
			delete: i18n.t("commons.permissionTypeEnum.delete"),
			screen: i18n.t("commons.permissionTypeEnum.screen"),
			action: i18n.t("commons.permissionTypeEnum.action")
		};

		Vue.prototype.$familyScreenType = {
			FamilyList: "Familias",
			Supplier: "Fornecedor",
			Invite: "Convite",
			InviteOffer: "Oferta",
			UserCondition: "Usuário"
		};

		Vue.prototype.$requirementType = {
			GENERAL: 2,
			SPECIFIC: 3,
			DEFINITION_OF_FAMILIES: 4,
			DEFINITION_OF_COMPANIES: 5
		};

		Vue.prototype.$displayType = {
			FIELD: 0,
			TABLE: 1
		};

		Vue.prototype.$requirementStep = {
			stepOne: 1,
			stepTwo: 2,
			stepThree: 3,
			stepFour: 4,
			stepFive: 5
		};

		//Modal de resposta do requisito
		Vue.prototype.$inviteTabsType = {
			inviteCreation: 1, // Cliente criando convite
			inviteProcess: 2, // Usuário atuando no convite
			offerCreation: 3 // Fornecedor se oferecendo
		};

		//Materials
		Vue.prototype.$protocolInviteTabsType = {
			creation: 1, // Cliente criando convite
			process: 2 // Usuário atuando no convite
		};

		//Modal de resposta do requisito
		Vue.prototype.$requirementResponseModalType = {
			requirementResponse: "requirementResponse", // Fornecedor respondendo os requisitos
			clientValidation: "clientValidation", // Cliente validando as respostas
			reprocess: "reprocess", // Cliente validando as respostas
			anyView: "anyView" // Visualizar estado atual do requisito
		};

		Vue.prototype.$permissionsName = {
			actors: i18n.t("commons.permissionNameEnum.actors"),
			blacklist: i18n.t("commons.permissionNameEnum.blacklist"),
			company: i18n.t("commons.permissionNameEnum.company"),
			companyGroup: i18n.t("commons.permissionNameEnum.companyGroup"),
			changeLog: i18n.t("commons.permissionNameEnum.changeLog"),
			emailActivity: i18n.t("commons.permissionNameEnum.emailActivity"),
			inviteFollowUp: i18n.t("commons.permissionNameEnum.inviteFollowUp"),
			enterpriseList: i18n.t("commons.permissionNameEnum.enterpriseList"),
			expiredRequirement: i18n.t("commons.permissionNameEnum.expiredRequirement"),
			family: i18n.t("commons.permissionNameEnum.family"),
			familyRequirements: i18n.t("commons.permissionNameEnum.familyRequirements"),
			inviteDetails: i18n.t("commons.permissionNameEnum.inviteDetails"),
			inviteSupplier: i18n.t("commons.permissionNameEnum.inviteSupplier"),
			logList: i18n.t("commons.permissionNameEnum.logList"),
			maskList: i18n.t("commons.permissionNameEnum.maskList"),
			offerList: i18n.t("commons.permissionNameEnum.offerList"),
			reportList: i18n.t("commons.permissionNameEnum.reportList"),
			requirement: i18n.t("commons.permissionNameEnum.requirement"),
			requirementGroup: i18n.t("commons.permissionNameEnum.requirementGroup"),
			response: i18n.t("commons.permissionNameEnum.response"),
			configuration: i18n.t("commons.permissionNameEnum.configuration"),
			exportSupplier: i18n.t("commons.permissionNameEnum.exportSupplier"),
			users: i18n.t("commons.permissionNameEnum.users"),
			vendorList: i18n.t("commons.permissionNameEnum.vendorList"),
			workflow: i18n.t("commons.permissionNameEnum.workflow"),
			workflowType: i18n.t("commons.permissionNameEnum.workflowType"),
			translation: i18n.t("commons.permissionNameEnum.translation"),
			translation: i18n.t("commons.permissionNameEnum.translation"),
			protocolOpening: i18n.t("commons.permissionNameEnum.protocolOpening"),
			protocolList: i18n.t("commons.permissionNameEnum.protocolList"),
			materialList: i18n.t("commons.permissionNameEnum.materialList"),
			supplierAssumeIdentity: i18n.t("commons.permissionNameEnum.supplierAssumeIdentity")
		};

		Vue.prototype.$inviteStatus = {
			PENDING: -1,
			IN_PROGRESS: 1,
			WAITING_INTEGRATION: 2,
			COMPLETED: 3,
			CANCELED: 4,
			PROCESS_ERROR: 5
		};

		Vue.prototype.$supplierCertificationStatus = {
			IN_PROGRESS: 1,
			EXPIRED: 2,
			COMPLETED: 3,
			CANCELED: 4
		};

		Vue.prototype.$inviteIdStatus = {
			IN_PROGRESS: 1,
			WAITING_INTEGRATION: 2,
			COMPLETED: 3,
			CANCELED: 4,
			PROCESS_ERROR: 5,
			OTHER: 6
		};

		Vue.prototype.$familyTree = {
			STANDARD: 0
		};

		Vue.prototype.$myContribution = {
			ACTUAL: i18n.t("commons.myContributionEnum.actual"),
			PAST: i18n.t("commons.myContributionEnum.past")
		};

		Vue.prototype.$statusFilter = {
			SUCCESS: i18n.t("commons.statusFilterEnum.success"),
			IN_PROGRESS: i18n.t("commons.statusFilterEnum.inProgress"),
			CANCELED: i18n.t("commons.statusFilterEnum.canceled"),
			PENDING: i18n.t("commons.statusFilterEnum.pending"),
			WAITING_INTEGRATION: i18n.t("commons.statusFilterEnum.waitingIntegration"),
			PROCESS_ERROR: i18n.t("commons.statusFilterEnum.processError")
		};

		Vue.prototype.$emailStatus = {
			processing: i18n.t("commons.emailStatusEnum.processing"),
			delivered: i18n.t("commons.emailStatusEnum.delivered"),
			not_delivered: i18n.t("commons.emailStatusEnum.notDelivered")
		};

		Vue.prototype.$emailEvent = {
			processed: i18n.t("commons.emailEventEnum.processed"),
			delivered: i18n.t("commons.emailEventEnum.delivered"),
			deferred: i18n.t("commons.emailEventEnum.deferred"),
			open: i18n.t("commons.emailEventEnum.open"),
			bounce: i18n.t("commons.emailEventEnum.bounce")
		};

		Vue.prototype.$ConditionType = {
			DEFAULT: 0,
			AVAILABLE_IF: 1,
			MANDATORY_IF: 2,
			DEFAULT_IF: 3,
			CONCATENATE_IF: 4,
			FILTER_IF: 5,
			APPROVE_IF: 6,
			REPROVE_IF: 7
		};

		Vue.prototype.$ConditionOperatorType = {
			DEFAULT: 0,
			EQUAL: 1,
			NOT_EQUAL: 2,
			IS_FILLED: 3,
			RESPONSE: 4,
			FIXED_VALUE: 5
		};

		Vue.prototype.$ConditionAnswerConcatenationType = {
			TEXT_OPTION: 1,
			CODE_ERP: 2
		};

		Vue.prototype.$ConditionAnswerConcatenationType = {
			TEXT_OPTION: 1,
			CODE_ERP: 2
		};

		Vue.prototype.$ConditionGroupCompositeOperatorType = {
			AND: 1,
			OR: 2
		};

		Vue.prototype.$FillerActor = {
			PUBLIC_CONSULTATIONS_ACTOR: -2,
			InviteActor: -3,
			INTEGRATION_ACTOR: -4
		};

		Vue.prototype.$IntegrationIdType = {
			ReceitaFederalCnpj: 1,
			ReceitaFederalCpf: 2,
			SimplesNacional: 3,
			TrabalhoEscravo: 4,
			Sintegra: 5,
			CadastroCentralizado: 6,
			RegularidadeEmpregador: 7,
			Coaf: 8,
			Ceis: 9,
			DebitosFederais: 10,
			DebitosEstaduais: 11,
			Serasa: 12,
			Suframa: 13,
			ReceitaFederalCnpjQsa: 14,
			Cnep: 15
		};

		Vue.prototype.$ConfigurationName = {
			RehomologationAuto: "RehomologationAuto",
			RehomologationDays: "RehomologationDays",
			RehomologationWorkflow: "RehomologationWorkflow"
		};

		Vue.prototype.$ActionButtonType = {
			Finish: i18n.t("buttons.finish"),
			Save: i18n.t("buttons.save"),
			SaveToCondition: "saveToCondition"
		};

		Vue.prototype.$IsActive = {
			ACTIVE: i18n.t("commons.active"),
			INACTIVE: i18n.t("commons.inactive")
		};

		Vue.prototype.$requirementActorRoleType = {
			VIEWER: 1,
			HIDE: 2,
			VALIDATOR: 3
		};

		Vue.prototype.$LetterCaseEnum = {
			All: 0,
			Upper: 1,
			Lower: 2
		};

		Vue.prototype.$requirementListStep = {
			TAB_REQUIREMENT: 1,
			TAB_SYSTEM_REQUIREMENT: 2
		};

		Vue.prototype.$FileLengthInMB = {
			MAX_FILE_LENGTH: 50
		};

		Vue.prototype.$PersonType = {
			PF: 1,
			PJ: 2,
			NIF: 3
		};

		Vue.prototype.$UserType = {
			Internal: i18n.t("commons.actorTypeInternal"),
			External: i18n.t("commons.actorTypeExternal"),
			Admin: i18n.t("commons.admin")
		};

		Vue.prototype.$IncludedIntegrationRequirementResponse = {
			SERASA: 12
		};

		Vue.prototype.$IdLanguage = {
			pt_BR: 1,
			en_US: 2,
			es_ES: 3
		};

		Vue.prototype.$ExportedStatus = {
			EXPORTED: 0,
			SUCCESS_IMPORTED: 1,
			ERROR_IMPORTED: 2
		};

		Vue.prototype.$InviteType = {
			NORMAL_CREATION: 0,
			MODIFICATION_CREATION: 1,
			MANUAL_REHOMOLOGATION: 2,
			AUTOMATIC_REHOMOLOGATION: 3
		};

		Vue.prototype.$InviteModelType = {
			CUSTOMER: 1,
			MATERIAL: 2
		};

		Vue.prototype.$EntityType = {
			SUPPLIER: 1,
			MATERIAL: 2
		};

		Vue.prototype.$protocolTabs = {
			PROTOCOL: 0,
			SUPPLIES: 1,
			BOND: 2,
			APPROVAL_REQUIREMENT: 3,
			FOLLOW_UP: 4
		};

		Vue.prototype.$WorkflowApplication = {
			CUSTOMER: 1,
			SUPPLIER: 2,
			MANUFACTOR: 3
		};

		Vue.prototype.$ActionRequirementType = {
			RESPONSED: 1,
			APPROVED: 2,
			REJECTED: 3,
			REEVALUATE: 4,
			CHANGED_VALIDITY: 5,
			RESPONSED_PARTIALLY: 6
		};

		Vue.prototype.$ActionStepType = {
			CREATED: 1,
			CONCLUDED: 2,
			CANCELED: 3,
			PROGRESS: 4
		};

		Vue.prototype.$ChangedPropertieType = {
			REQUIREMENT_VALIDITY: 1,
			REQUIREMENT_OBSERVATION: 2,
			REQUIREMENTQUESTION_ANSWER: 3
		};

		Vue.prototype.$StepFieldVisualizationType = {
			OBRIGATORY: 1,
			DISABLED: 2,
			OPTIONAL: 3
		};

		Vue.prototype.$InviteFieldTab = {
			INVITE_DETAILS: 1,
			SUPPLIER_DETAILS: 2,
			CONTACT_DATA: 3,
			SUPPLIES: 4,
			LINK: 5,
			BANK_DATA: 6
		};

		Vue.prototype.$PeriodType = {
			NONE: 1,
			ACTING_DATE: 2,
			OPENING_DATE: 3,
			CONCLUSION_DATE: 4
		};

		Vue.prototype.$EnvironmentUniqueKeyQuestion = {
			CMAA_AutorizaBoleto: 3
		};

		Vue.prototype.$ResponseIndexReady = {
			NotReady: 0,
			FilledFormReady: 1,
			VallidFormReady: 2
		};

		Vue.prototype.$IframeMessageSource = {
			REQUIREMENT_CREATED: 1,
			REQUIREMENT_RESPONSE: 2,
			REQUIREMENT_DELETED: 3
		};
	}
});
